import { border } from "@chakra-ui/react";

export default {
    parts: [
        'closeButton',
        'header',
        'body',
        'message',
        'primaryButton',
        'secondaryButton',
        'cta'
    ],
    baseStyle: {
        closeButton: {
            background: 'transparent',
            display: 'block',
            _hover: {
                background: 'transparent'
            },
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: 'none',
            padding: {base: '12px 16px', lg: '12px 16px'},
            borderBottom: '1px solid',
            borderColor: 'gray.50'
        },
        headerTitle: {
            textStyle: 'webH2',
            color: 'black'
        },
        body: {
            paddingLeft: {base: '16px !important'},
            paddingRight: {base: '16px !important'},
            paddingTop: {base: '24px !important'},
            paddingBottom: {base: '145px !important', lg: '0 !important'},
        },
        message: {
            textStyle: 'bodySmRegular',
            marginBottom: {base: 6}
        },
        cta: {
            marginBottom: {base : 2},
            width: {base: '100%'}
        }
    }
}
